import { useParams } from 'src/routes/hook';
import OrgUsersCreate from 'src/sections/superadmin/organization-users-create';

const OwnerUsersCreate = () => {
  const { orgId } = useParams();
  return <OrgUsersCreate inCampaigns={true} organizationId={orgId} />;
};

export default OwnerUsersCreate;
